export default "__VITE_ASSET__BMCgC2nS__"